import {Injectable} from '@angular/core';
import {EntregaPedidoService} from './entrega-pedido.service';
import {PreCargaService} from '../components/roteirizacao/services/pre-carga.service';
import {FiltroRoteirizacaoService} from '../components/roteirizacao/component/filtro-dialog/config/filtro-roteirizacao.service';

@Injectable({providedIn: 'root'})
export class IndexedDbService {

  constructor(private preCargaService: PreCargaService,
              private entregaPedidoService: EntregaPedidoService,
              private filtroRoteirizacaoService: FiltroRoteirizacaoService) {
  }

  limparLocalStorage() {
    this.preCargaService.removerPrecargaStorage();
    this.entregaPedidoService.removerPedidosStorage();
    this.filtroRoteirizacaoService.removerFiltrosStorage();
    this.preCargaService.removerOrdemGridPrecargaStorage();
  }
}
